import { Component } from "@angular/core";
import { EdpMouseEventService } from "./edp-mouse-event.service";

@Component({
  selector: "app-edp-mouse-event",
  templateUrl: "./edp-mouse-event.component.html"
})
export class EdpMouseEventComponent {

  constructor(private edpMouseEventService: EdpMouseEventService) { }

  public mouseevent($event: Event): void {
    this.edpMouseEventService.emitMouseEvent($event);
  }

}
